import { lazyNamed } from 'src/utils/lazyNamed';

const Payouts = {
  Statistics: lazyNamed(() => import('./containers/Statistics'), 'Statistics'),
  Documents: lazyNamed(() => import('./containers/Documents'), 'Documents'),
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
};

export default Payouts;
